import MainPageWrapper from '../../global/components/MainPageWrapper'
import RouteOptimizationCorrector from './RouteOptimizationCorrector'
import AddCompletedInvoice from './AddCompletedInvoice'
import ScheduleChangeImpactTester from './ScheduleChangeImpactTester'
import DaySettingsMaintenance from './DaySettingsMaintenance'
import AdjustDeliveryCandidateStatuses from './AdjustDeliveryCandidateStatuses'
import MoveSchedulingDataToNewDay from './MoveSchedulingDataToNewDay'

import styles from './styles.module.css'

export default function JmulletTools() {
  return (
    <MainPageWrapper>
      <h1>jmullet tools</h1>
      <div className={styles.toolsHolder}>
        <DaySettingsMaintenance />
        <ScheduleChangeImpactTester />
        <AdjustDeliveryCandidateStatuses />
        <MoveSchedulingDataToNewDay />
        <RouteOptimizationCorrector />
        <AddCompletedInvoice />
      </div>
    </MainPageWrapper>
  )
}
